// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1Cazn","left":"StickyBox_left__fa4id","right":"StickyBox_right__HsivV"};